import '../styles/resources.scss'
import '../../../../../node_modules/react-alice-carousel/lib/scss/alice-carousel.scss'
import {useEffect, useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {ResourceDocuments} from '../components/ResourceDocuments'
import '../../../../app/modules/widgets/components/styles/rectangularTabs.scss'
import {useIntl} from 'react-intl'

export const Resources = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const {formatMessage} = useIntl()
  const [tab, setTab] = useState(1)
  const options = [
    {
      slug: 'documents',
      title: formatMessage({id: 'Documents'}),
      subTitle: formatMessage({id: 'Essential Startup Docs and Templates'}),
    },
  ]

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const tabParam = params.get('tab')
    const tabIndex = options.findIndex((opt) => opt.slug.toLowerCase() === tabParam?.toLowerCase())
    if (tabIndex !== -1) {
      setTab(tabIndex + 1)
    } else {
      setTab(1) // Default to the first tab
      navigate(`${location.pathname}?tab=${options[0].slug.toLowerCase()}`)
    }
  }, [location.search]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleTabChange = (index: number) => {
    setTab(index + 1)
    navigate(`${location.pathname}?tab=${options[index].slug.toLowerCase()}`)
  }

  return (
    <>
      <div className=''>
        <div
          className='d-flex gap-3 col-md-8 col-12'
          style={{
            display: 'flex',
            flexWrap: 'nowrap',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
        >
          {options.map((opt, index) => (
            <div
              key={index}
              className={
                `col options-container p-4 align-content-center cursor-pointer` +
                (tab === index + 1 ? ' selected-option' : '')
              }
              style={{width: '200px', flex: '0 0 auto'}}
              onClick={() => handleTabChange(index)}
            >
              <h1 className='m-0'>{formatMessage({id: opt.title})}</h1>
              <p className='mt-2 wrap'>{formatMessage({id: opt.subTitle})}</p>
            </div>
          ))}
        </div>

        <div className='col-12 mt-5 mb-9 w-100'>
          {tab === 1 && (
            <>
              <ResourceDocuments type='resources' />
            </>
          )}
        </div>
      </div>
    </>
  )
}
